// Gemeinsamer HTTP-Client für authentifizierte Aufrufe an unsere /api/*-Endpoints.
// Hängt Firebase-ID-Token + JSON-Header an, normalisiert Fehler.

import { authHeader } from './authHeader';

// Native iOS: relative /api/... löst auf capacitor://localhost (kein Server).
// Auf native immer den absoluten Vercel-Host verwenden.
const _nativeBase = typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.()
  ? 'https://app.redcrypto.de' : '';

export class ApiError extends Error {
  constructor(message, { status = 0, requiresUpgrade = false } = {}) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.requiresUpgrade = requiresUpgrade;
  }
}

export async function apiPost(path, body) {
  const url = path.startsWith('/') ? `${_nativeBase}${path}` : path;
  let res;
  try {
    res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(await authHeader()),
      },
      body: JSON.stringify(body || {}),
    });
  } catch {
    throw new ApiError('Netzwerkfehler — bitte Internetverbindung prüfen.', { status: 0 });
  }
  let data = {};
  try { data = await res.json(); } catch { /* leerer Body ok */ }
  if (!res.ok) {
    throw new ApiError(data.error || `Fehler ${res.status}`, {
      status: res.status,
      requiresUpgrade: !!data.requiresUpgrade,
    });
  }
  return data;
}
